import { TenantsSearchSideFilters } from '../types';

import { getEmptyTenantsSearchAllFilters } from './getEmptyTenantsSearchAllFilters';
import { mapTenantsSearchAllFiltersToSideFilters } from './mapTenantsSearchAllFiltersToSideFilters';

export function getEmptyTenantsSearchSideFilters(): TenantsSearchSideFilters {
  const allFilters = getEmptyTenantsSearchAllFilters();
  return mapTenantsSearchAllFiltersToSideFilters(allFilters);
}
